module.exports = __webpack_public_path__ + "static/media/pdf.6fd45e6d.svg";